import { render, staticRenderFns } from "./ActivatePlan.vue?vue&type=template&id=6ba33e4c&scoped=true&"
import script from "./ActivatePlan.vue?vue&type=script&lang=js&"
export * from "./ActivatePlan.vue?vue&type=script&lang=js&"
import style0 from "./ActivatePlan.vue?vue&type=style&index=0&id=6ba33e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba33e4c",
  null
  
)

export default component.exports